module.exports = __webpack_public_path__ + "static/media/3.45a50848.jpg";